import styles from "./TitleText.module.scss";

type Props = {
  heading?: string;
  subHeading?: string;
};

export function TitleText({ heading, subHeading }: Props) {
  return (
    <h1 className={styles.headingWrapper}>
      <span className={styles.heading} data-testid="heading">
        {heading}
      </span>
      {subHeading && (
        <span className={styles.subHeading} data-testid="sub-heading">
          {subHeading}
        </span>
      )}
    </h1>
  );
}
